module.exports = __webpack_public_path__ + "static/as-c7a6bb4e0ed4dcc8cfc232a69516a8d7.svg";